/* eslint react/forbid-prop-types: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as uuid from "react-native-uuid";
import { arrayMove } from "react-sortable-hoc";
import { Button, Row, Col, Glyphicon, Panel, Navbar } from "react-bootstrap";
// actions & helpers
import { DEFAULT_JOB } from "../../types";
import { validJob, getJobErrors, resetJobItemForm } from "../../actions/jobs";
// components
import RunsheetForm from "../../forms/RunsheetForm";
import JobSortList from "../jobs/JobSortList";
import JobEdit from "../jobs/JobEdit";
import Loading from "../Loading";
import JobForm from "../../forms/JobForm";
import RunsheetControllerCancel from "./RunsheetControllerCancel";
import Client from "../../Client";
import ViewOnMap from "../jobs/ViewOnMap";

const NoSelectedJob = () => <div className="no-selected-job">Select a job</div>;

class RunsheetController extends Component {
  static generateUUID() {
    return uuid.v4();
  }

  static removeItem(array, index) {
    return [...array.slice(0, index), ...array.slice(index + 1)];
  }

  constructor(props) {
    super(props);

    this.state = {
      runsheet: props.initialRunsheet,
      activeJobId: props.initialRunsheet.jobs[0].externalId,
      activeJobKey: "uuid",
      activeJobItemUUID: "",
      activeJobItemKey: "",
      errors: [],
      saving: false,
      serverErrors: {}
    };

    // Misc
    this.goBack = this.goBack.bind(this);
    // Runsheet
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleRunsheetChange = this.handleRunsheetChange.bind(this);
    this.saveRunsheet = this.saveRunsheet.bind(this);
    // Job
    this.addJob = this.addJob.bind(this);
    this.updateJob = this.updateJob.bind(this);
    this.changeActiveJob = this.changeActiveJob.bind(this);
    this.updateJobSequence = this.updateJobSequence.bind(this);
    this.updateJobLocationType = this.updateJobLocationType.bind(this);
    this.removeJob = this.removeJob.bind(this);
    // Job item
    this.handleAddJobItem = this.handleAddJobItem.bind(this);
    this.handleEditJobItem = this.handleEditJobItem.bind(this);
    this.handleRemoveJobItem = this.handleRemoveJobItem.bind(this);
  }

  // MISC
  goBack() {
    this.props.history.goBack();
  }

  // RUNSHEET
  handleRunsheetChange(event) {
    const updatedRunsheet = {
      ...this.state.runsheet,
      [event.target.name]: event.target.value
    };
    this.setState({ runsheet: updatedRunsheet });
  }

  handleDateChange(date) {
    this.setState(prevState => ({
      runsheet: {
        ...prevState.runsheet,
        scheduledAt: date.toISOString()
      }
    }));
  }

  handleVehicleChange = vehicleId => {
    if (vehicleId) {
      const updatedRunsheet = {
        ...this.state.runsheet,
        vehicle: { id: vehicleId }
      };
      this.setState({ runsheet: updatedRunsheet });
    } else {
      const updatedRunsheet = {
        ...this.state.runsheet
      };
      delete updatedRunsheet.vehicle;
      this.setState({ runsheet: updatedRunsheet });
    }
  };

  saveRunsheet() {
    this.setState({ saving: true });
    const { runsheet } = this.state;
    let { errors } = this.state;
    const { externalId, name } = runsheet;

    if (externalId.trim() === "") {
      errors.push("externalId");
    } else {
      errors = errors.filter(error => error !== "externalId");
    }

    if (name.trim() === "") {
      errors.push("name");
    } else {
      errors = errors.filter(error => error !== "name");
    }

    this.setState({ errors });
    if (errors.length) {
      this.setState({ saving: false });
      return;
    }

    if (this.props.mode === "CREATE" || this.props.mode === "COPY") {
      Client.createRunsheet(runsheet)
        .then(response => this.props.history.push(`/runsheets/${response.id}`))
        .catch(error => {
          const errorMessage = error.response.data.error;
          if (
            errorMessage.includes(
              "An active runsheet already exists with id of"
            )
          ) {
            const serverErrors = {
              externalId: errorMessage.split(":")[1].trim()
            };
            this.setState({ serverErrors, saving: false });
          }
        });
    } else {
      Client.updateRunsheet(runsheet.id, runsheet).then(response =>
        this.props.history.push(`/runsheets/${response.id}`)
      );
    }
  }
  // RUNSHEET - END

  // JOBS
  addJob() {
    const { runsheet, activeJobId, activeJobKey } = this.state;
    if (activeJobId) {
      if (activeJobKey === "id") {
        const j = runsheet.jobs.find(
          job => job.id === parseInt(activeJobId, 10)
        );
        const errors = getJobErrors(j);
        if (errors.length) {
          this.setState({ errors });
        } else {
          const sequence = runsheet.jobs.length + 1;
          const plannedStart = runsheet.scheduledAt;
          const job = {
            ...DEFAULT_JOB,
            externalId: RunsheetController.generateUUID(),
            seq: sequence,
            startAt: plannedStart
          };
          const updatedRunsheet = {
            ...runsheet,
            jobs: runsheet.jobs.concat(job)
          };
          this.setState({
            runsheet: updatedRunsheet,
            activeJobKey: "uuid",
            activeJobId: job.externalId,
            errors: []
          });
        }
      } else {
        const j = runsheet.jobs.find(job => job.externalId === activeJobId);
        const errors = getJobErrors(j);
        if (errors.length) {
          this.setState({ errors });
        } else {
          const sequence = runsheet.jobs.length + 1;
          const plannedStart = runsheet.scheduledAt;
          const job = {
            ...DEFAULT_JOB,
            externalId: RunsheetController.generateUUID(),
            seq: sequence,
            startAt: plannedStart
          };
          const updatedRunsheet = {
            ...runsheet,
            jobs: runsheet.jobs.concat(job)
          };
          this.setState({
            runsheet: updatedRunsheet,
            activeJobKey: "uuid",
            activeJobId: job.externalId,
            errors: []
          });
        }
      }
    } else {
      const sequence = runsheet.jobs.length + 1;
      const plannedStart = runsheet.scheduledAt;
      const job = {
        ...DEFAULT_JOB,
        externalId: RunsheetController.generateUUID(),
        seq: sequence,
        startAt: plannedStart
      };
      const updatedRunsheet = {
        ...runsheet,
        jobs: runsheet.jobs.concat(job)
      };
      this.setState({ runsheet: updatedRunsheet });
      if (activeJobId === "") {
        this.setState({ activeJobKey: "uuid", activeJobId: job.externalId });
      }
    }
  }

  // If uuid is required by 'import', then we could always use UUID as there
  // will be one when editing and TM can assign on when creating.
  // Removes 'duplication' of sorts
  changeActiveJob(activeJob) {
    if (activeJob.key === "id") {
      const { key, value } = activeJob;

      const { runsheet, activeJobKey, activeJobId } = this.state;
      if (activeJobKey) {
        if (activeJobKey === "id") {
          const j = runsheet.jobs.find(
            job => job.id === parseInt(activeJobId, 10)
          );
          const errors = getJobErrors(j);
          if (errors.length) {
            this.setState({ errors });
          } else {
            this.setState({
              activeJobKey: key,
              activeJobId: `${value}`,
              errors
            });
          }
        } else {
          const j = runsheet.jobs.find(job => job.externalId === activeJobId);
          const errors = getJobErrors(j);
          if (errors.length) {
            this.setState({ errors });
          } else {
            this.setState({
              activeJobKey: key,
              activeJobId: `${value}`,
              errors
            });
          }
        }
      } else {
        this.setState({ activeJobKey: key, activeJobId: `${value}` });
      }
    } else {
      const { runsheet, activeJobId } = this.state;
      const jobExternalId = activeJob.value;
      const currentJob = runsheet.jobs.find(
        job => job.externalId === activeJobId
      );
      if (currentJob) {
        if (jobExternalId !== activeJobId) {
          if (validJob(currentJob)) {
            this.setState({
              activeJobId: jobExternalId,
              activeJobKey: "uuid",
              activeJobItemUUID: "",
              errors: []
            });
          } else {
            const errors = getJobErrors(currentJob);
            this.setState({ errors });
          }
        }
      } else {
        this.setState({
          activeJobId: jobExternalId,
          activeJobKey: "uuid",
          errors: []
        });
      }
    }
  }

  updateJobSequence({ oldIndex, newIndex }) {
    const { runsheet } = this.state;
    const jobIds = runsheet.jobs.map(job => job.externalId || job.id);
    const updatedJobIdSequence = arrayMove(jobIds, oldIndex, newIndex);
    const updatedJobSequence = updatedJobIdSequence.map((jobId, index) => {
      const job = runsheet.jobs.find(
        j => j.externalId === jobId || j.id === parseInt(jobId, 10)
      );
      return { ...job, seq: index + 1 };
    });
    const updatedRunsheet = { ...runsheet, jobs: updatedJobSequence };
    this.setState({ runsheet: updatedRunsheet });
  }

  updateJob(values) {
    if (this.state.activeJobKey === "id") {
      const jobs = this.state.runsheet.jobs.map(job => {
        if (job.id === parseInt(this.state.activeJobId, 10)) {
          const updatedJob = { ...job, ...values };
          if (updatedJob.stop.location.type.code === "JOB") {
            updatedJob.stop.location.name = updatedJob.customerName;
          }
          return updatedJob;
        }

        return job;
      });
      const runsheet = { ...this.state.runsheet, jobs };
      this.setState({ runsheet });
    } else {
      const jobs = this.state.runsheet.jobs.map(job => {
        if (job.externalId === this.state.activeJobId) {
          const updatedJob = { ...job, ...values };
          if (updatedJob.stop.location.type.code === "JOB") {
            updatedJob.stop.location.name = updatedJob.customerName;
          }
          return updatedJob;
        }

        return job;
      });
      const runsheet = { ...this.state.runsheet, jobs };
      this.setState({ runsheet });
    }
  }

  updateJobLocationType(locationType) {
    if (this.state.activeJobKey === "id") {
      const jobs = this.state.runsheet.jobs.map(job => {
        if (job.id === this.state.activeJobId.toString()) {
          if (locationType === "JOB") {
            return {
              ...job,
              stop: { location: { name: job.customerName, type: { code: locationType } } }
            };
          }
          return {
            ...job,
            stop: { location: { name: "", type: { code: locationType } } }
          };
        }

        return job;
      });
      const runsheet = { ...this.state.runsheet, jobs };
      this.setState({ runsheet });
    } else {
      const jobs = this.state.runsheet.jobs.map(job => {
        if (job.externalId === this.state.activeJobId) {
          if (locationType === "JOB") {
            return {
              ...job,
              stop: { location: { name: job.customerName, type: { code: locationType } } }
            };
          }
          return {
            ...job,
            stop: { location: { name: "", type: { code: locationType } } }
          };
        }

        return job;
      });
      const runsheet = { ...this.state.runsheet, jobs };
      this.setState({ runsheet });
    }
  }

  findJobIndexById = (jobs, id) => jobs.findIndex((job) => id === job.id);
  findJobIndexByExternalId = (jobs, externalId) =>
    jobs.findIndex((job) => externalId === job.externalId);

  removeJobFromArray = (array, index) => {
    if (index >= 0) {
      const newArray = array.slice();
      newArray.splice(index, 1);
      return newArray;
    }

    return array
  }

  reSequenceJobs = (jobs) => jobs.map((job, index) => ({ ...job, seq: index + 1 }));

  removeJob(job) {
    if (job.id) {
      const runsheetId = this.state.runsheet.id;
      Client.removeJob(runsheetId, job.id).then(() => {
        this.setState(prevState => {
          const jobs = prevState.runsheet.jobs;
          const index = this.findJobIndexByExternalId(jobs, job.externalId)
          const remainingJobs = this.removeJobFromArray(jobs, index)
          const updatedJobs = this.reSequenceJobs(remainingJobs)
          const updatedRunsheet = { ...prevState.runsheet, jobs: updatedJobs };

          return {
            activeJobId: "",
            activeJobKey: "",
            runsheet: updatedRunsheet
          };
        });
      })
    } else {
      this.setState(prevState => {
        const jobs = prevState.runsheet.jobs;
        const index = this.findJobIndexByExternalId(jobs, job.externalId)
        const remainingJobs = this.removeJobFromArray(jobs, index)
        const updatedJobs = this.reSequenceJobs(remainingJobs)
        const updatedRunsheet = { ...prevState.runsheet, jobs: updatedJobs };

        return {
          activeJobId: "",
          activeJobKey: "",
          runsheet: updatedRunsheet
        };
      });
    }
  }
  // JOBS - END

  // JOB ITEM
  handleAddJobItem(attributes) {
    const { runsheet, activeJobId, activeJobItemUUID } = this.state;
    if (attributes.uuid || attributes.id) {
      const job = runsheet.jobs.find(j => j.externalId === activeJobId);
      const jobItems = job.jobItems.map(ji => {
        if (ji.uuid === activeJobItemUUID || ji.id === activeJobItemUUID) {
          return { ...ji, ...attributes };
        }

        return ji;
      });
      const jobs = runsheet.jobs.map(j => {
        if (j.externalId === activeJobId) {
          return { ...j, jobItems };
        }

        return j;
      });
      const updatedRunsheet = { ...runsheet, jobs };
      this.setState({ runsheet: updatedRunsheet, activeJobItemUUID: "" });
      this.props.resetJobItemForm();
    } else {
      // modify form to use nested item, check here for uuid, then act accordingly (similar to update job)
      const jobItem = {
        uuid: RunsheetController.generateUUID(),
        ...attributes
      };
      const jobs = runsheet.jobs.map(job => {
        if (job.externalId === activeJobId) {
          return { ...job, jobItems: job.jobItems.concat(jobItem) };
        }

        return job;
      });
      const updatedRunsheet = { ...runsheet, jobs };
      this.setState({ runsheet: updatedRunsheet });
      this.props.resetJobItemForm();
    }
  }

  handleEditJobItem(jobItem) {
    if (jobItem.id) {
      this.setState({ activeJobItemKey: "id", activeJobItemUUID: jobItem.id });
    } else {
      this.setState({
        activeJobItemKey: "uuid",
        activeJobItemUUID: jobItem.uuid
      });
    }
  }

  handleRemoveJobItem(jobItemIndex) {
    const { runsheet, activeJobId } = this.state;
    const job = runsheet.jobs.find(j => j.externalId === activeJobId);
    const jobItem = job.jobItems[jobItemIndex];
    if (jobItem.id) {
      Client.deleteJobItem(runsheet.id, job.id, jobItem.item.id).then(() => {
        const updatedJobItems = RunsheetController.removeItem(
          job.jobItems,
          jobItemIndex
        );
        const jobs = runsheet.jobs.map(j => {
          if (j.externalId !== job.externalId) {
            return j;
          }

          return { ...job, jobItems: updatedJobItems };
        });
        const updatedRunsheet = { ...runsheet, jobs };
        this.setState({ runsheet: updatedRunsheet });
      });
    } else {
      const updatedJobItems = RunsheetController.removeItem(
        job.jobItems,
        jobItemIndex
      );
      const jobs = runsheet.jobs.map(j => {
        if (j.externalId !== job.externalId) {
          return j;
        }

        return { ...job, jobItems: updatedJobItems };
      });
      const updatedRunsheet = { ...runsheet, jobs };
      this.setState({ runsheet: updatedRunsheet });
    }
  }
  // JOB ITEM - END

  render() {
    const { runsheet } = this.state;

    if (runsheet) {
      const {
        activeJobKey,
        activeJobId,
        activeJobItemUUID,
        activeJobItemKey,
        errors
      } = this.state;

      let job;
      if (activeJobId) {
        if (activeJobKey === "id") {
          job = runsheet.jobs.find(j => j.id === parseInt(activeJobId, 10));
        } else {
          job = runsheet.jobs.find(j => j.externalId === activeJobId);
        }
      }

      let activeJobItem;
      if (activeJobItemUUID) {
        if (activeJobItemKey === "id") {
          activeJobItem = job.jobItems.find(ji => ji.id === activeJobItemUUID);
        } else {
          activeJobItem = job.jobItems.find(
            ji => ji.uuid === activeJobItemUUID
          );
        }
      }

      let saveText;
      if (
        (this.props.mode === "CREATE" || this.props.mode === "COPY") &&
        this.state.saving
      ) {
        saveText = "CREATING RUNSHEET...";
      } else if (this.props.mode === "CREATE" || this.props.mode === "COPY") {
        saveText = "CREATE RUNSHEET";
      }

      if (this.props.mode === "EDIT" && this.state.saving) {
        saveText = "UPDATING RUNSHEET...";
      } else if (this.props.mode === "EDIT") {
        saveText = "UPDATE RUNSHEET";
      }

      // const createErrors = this.props.createErrors;
      const serverErrors = this.state.serverErrors;
      const sortedJobs = runsheet.jobs.sort((a, b) => a.seq - b.seq);
      return (
        <div>
          {serverErrors.externalId && (
            <Panel bsStyle="danger">
              <Panel.Heading>
                <Panel.Title componentClass="h3">
                  Errors with Runsheet
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body>
                <p>{serverErrors.externalId}</p>
              </Panel.Body>
            </Panel>
          )}
          <RunsheetForm
            handleDateChange={this.handleDateChange}
            handleRunsheetChange={this.handleRunsheetChange}
            handleVehicleChange={this.handleVehicleChange}
            runsheet={runsheet}
            errors={errors}
          />

          <div style={{ marginBottom: 65 }}>
            <Row>
              <Col md={7}>
                <div className="job-sort">
                  <h3 className="title">
                    <Glyphicon glyph="briefcase" style={{ verticalAlign: "text-top" }} />{" "}
                    Jobs{" "}
                    <Button
                      bsStyle="primary"
                      bsSize="small"
                      onClick={this.addJob}
                      style={{ verticalAlign: "text-top" }}
                    >
                      <Glyphicon glyph="plus" /> ADD NEW JOB
                    </Button>
                    <ViewOnMap runsheet={runsheet} jobs={sortedJobs} />
                  </h3>

                  <JobSortList
                    runsheet={runsheet}
                    jobs={sortedJobs}
                    activeJobKey={activeJobKey}
                    activeJobId={activeJobId}
                    addJob={this.addJob}
                    changeActiveJob={this.changeActiveJob}
                    updateJobSequence={this.updateJobSequence}
                    removeJob={this.removeJob}
                  />
                </div>
              </Col>
              <Col md={5}>
                <h3 className="title">
                  <Glyphicon glyph="briefcase" /> Job Form
                </h3>
                {job ? (
                  <JobForm
                    job={job}
                    updateJob={this.updateJob}
                    updateJobLocationType={this.updateJobLocationType}
                    errors={errors}
                  />
                ) : (
                  <NoSelectedJob />
                )}
              </Col>
            </Row>

            <JobEdit
              job={job}
              updateJob={this.updateJob}
              updateJobLocationType={this.updateJobLocationType}
              activeJobItem={activeJobItem}
              handleAddJobItem={this.handleAddJobItem}
              handleEditJobItem={this.handleEditJobItem}
              handleRemoveJobItem={this.handleRemoveJobItem}
              errors={errors}
            />
          </div>

          <Navbar fluid fixedBottom>
            <div style={{ display: "inline-block", marginTop: 5 }}>
              <RunsheetControllerCancel onCancel={this.goBack} />
            </div>

            <Button
              bsStyle="primary"
              className="pull-right"
              onClick={this.saveRunsheet}
              style={{ marginTop: 5 }}
            >
              {saveText}
            </Button>
          </Navbar>
        </div>
      );
    }

    return <Loading />;
  }
}

const mapStateToProps = state => {
  const vehicles = state.vehicles.container;

  return { vehicles };
};

const mapDispatchToProps = {
  resetJobItemForm
};

RunsheetController.propTypes = {
  initialRunsheet: PropTypes.object.isRequired,
  mode: PropTypes.string,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired
  }).isRequired,
  resetJobItemForm: PropTypes.func.isRequired
};
RunsheetController.defaultProps = {
  mode: "CREATE",
  createErrors: {}
};

export default connect(mapStateToProps, mapDispatchToProps)(RunsheetController);



// WEBPACK FOOTER //
// ./src/components/runsheets/RunsheetController.js